import dayjs from "dayjs";
import * as XLSX from "xlsx";

import { formatRutWithDots } from "./libroCompras";

import type { LibroComprasAmounts, LibroComprasReport } from "./libroCompras";

// Reproduce the Softland "Libro de Compras" .xls layout exactly so contabilidad can diff it
// line-for-line: title + período + moneda header block, the 12 columns, one section per SII
// document type with its subtotal, and the Total General. Amounts are written as raw numbers.

export interface LibroComprasExportMeta {
  empresa: string;
  from: string; // YYYY-MM-DD
  to: string; // YYYY-MM-DD
}

const HEADERS = [
  "Cod. SII",
  "N. Documento",
  "Corr. Interno",
  "Fecha",
  "RUT",
  "Nombre del Proveedor",
  "NETO AFECTO",
  "NETO EXENTO",
  "IVA CREDITO",
  "IVA NO RECUPERABLE",
  "IVA SUPERMERCADOS",
  "Total",
];

const COL_WIDTHS = [
  { wch: 10 }, // Cod. SII
  { wch: 14 }, // N. Documento
  { wch: 14 }, // Corr. Interno
  { wch: 12 }, // Fecha
  { wch: 14 }, // RUT
  { wch: 52 }, // Nombre del Proveedor
  { wch: 16 }, // NETO AFECTO
  { wch: 16 }, // NETO EXENTO
  { wch: 16 }, // IVA CREDITO
  { wch: 18 }, // IVA NO RECUPERABLE
  { wch: 18 }, // IVA SUPERMERCADOS
  { wch: 16 }, // Total
];

type Cell = string | number;

const fmtDate = (d: string) => dayjs(d).format("DD/MM/YYYY");

// The six numeric columns in order (NETO AFECTO … Total).
const amountCells = (a: LibroComprasAmounts): number[] => [
  a.netoAfecto,
  a.netoExento,
  a.ivaCredito,
  a.ivaNoRecuperable,
  a.ivaSupermercado,
  a.total,
];

export function exportLibroComprasToExcel(
  report: LibroComprasReport,
  meta: LibroComprasExportMeta
) {
  const aoa: Cell[][] = [];

  aoa.push(["Libro de Compras Ordenado Por fecha"]);
  aoa.push([]);
  aoa.push([` Desde: ${fmtDate(meta.from)}  Hasta: ${fmtDate(meta.to)}`]);
  aoa.push([" Moneda: Peso Chileno"]);
  aoa.push([]);
  aoa.push([]);
  aoa.push(HEADERS);
  aoa.push([]);

  for (const section of report.sections) {
    aoa.push([section.title]);
    aoa.push([]);
    for (const line of section.lines) {
      aoa.push([
        line.siiCode ?? "",
        line.folio,
        line.corrInterno,
        fmtDate(line.emissionDate),
        formatRutWithDots(line.rut),
        line.razonSocial,
        ...amountCells(line),
      ]);
    }
    aoa.push([]);
    aoa.push([`Total ${section.title}`, "", "", "", "", "", ...amountCells(section)]);
    aoa.push([]);
    aoa.push([]);
  }

  aoa.push([
    "Total General",
    "",
    "",
    "",
    "",
    "",
    ...amountCells(report.grandTotal),
  ]);

  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet(aoa);
  ws["!cols"] = COL_WIDTHS;
  XLSX.utils.book_append_sheet(wb, ws, "Libro de Compras");
  XLSX.writeFile(wb, `Libro_Compras_${meta.from}_${meta.to}.xlsx`);
}
